import { NgModule } from "@angular/core";
import * as Components from './';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { NgxSliderModule } from "@angular-slider/ngx-slider";


@NgModule({
    imports: [
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        NgbModule,
        NgxSliderModule,
        FontAwesomeModule,
        CommonModule
    ],
    exports: [
        Components.LeftSideMenu,
        Components.TopMenu,
        Components.Footer,
        Components.TacticPlayer,
        Components.PlayMakerModal,
        Components.DeleteConfirmationModal,
        Components.OrderConfirmationModal,
        Components.EditSubstitutionModal,
        Components.EditTacticChangeModal,
        Components.PlayerSettingsModal,
        Components.TacticPlayerInfo,
        Components.TacticPlayerVerticalInfo,
        Components.TacticPlayer,
        Components.PlayerSkillsModal,
        Components.PlayerModal,
        Components.ColoredSkill,
        Components.TacticPlayerSkills,
        Components.TacticPlayerSettings,
        Components.TacticPlayerGeneral,
        Components.NextFixture,
        Components.NextFixtureStadium,
        Components.NextFixtureInjury,
        Components.NextFixtureBan,
        Components.CopyTacticModal,
        Components.AdminLeftSideMenu,
        Components.AdminMobileMenu,
        Components.DrawingEuroQuotas,
        Components.DrawingPlayOff,
        Components.TeamShortModal,
        Components.DrawingGroup,
        Components.DrawingFinal,
        Components.TeamPlayersList,
        Components.TeamData,
        Components.ChangeSquadNumberModal,
        Components.PlayerFormIndicatorComponent,
        Components.PlayerMoraleIndicatorComponent,
        Components.DrawingNationalPairs,
        Components.DrawWCGroupLooserModal,
        Components.NationalTeamShortModal,
        Components.DrawingWCPlayOff,
        Components.MaintenanceLog,
        Components.ChangeStandardRoleOrderModal,
        Components.OrderComponent,
        Components.DrawingClubWCGroup,
        Components.DrawingClubWCPlayOff,
        Components.PlayerPositionFilterModal,
        Components.PlayerAgeFilterModal,
    ],
    declarations: [
        Components.LeftSideMenu,
        Components.TopMenu,
        Components.Footer,
        Components.TacticPlayer,
        Components.PlayMakerModal,
        Components.DeleteConfirmationModal,
        Components.OrderConfirmationModal,
        Components.EditSubstitutionModal,
        Components.EditTacticChangeModal,
        Components.PlayerSettingsModal,
        Components.TacticPlayerInfo,
        Components.TacticPlayerVerticalInfo,
        Components.PlayerSkillsModal,
        Components.PlayerModal,
        Components.ColoredSkill,
        Components.TacticPlayerSkills,
        Components.TacticPlayerSettings,
        Components.TacticPlayerGeneral,
        Components.NextFixture,
        Components.NextFixtureStadium,
        Components.NextFixtureInjury,
        Components.NextFixtureBan,
        Components.CopyTacticModal,
        Components.AdminLeftSideMenu,
        Components.AdminMobileMenu,
        Components.DrawingEuroQuotas,
        Components.DrawingPlayOff,
        Components.TeamShortModal,
        Components.DrawingGroup,
        Components.DrawingFinal,
        Components.TeamPlayersList,
        Components.TeamData,
        Components.ChangeSquadNumberModal,
        Components.PlayerFormIndicatorComponent,
        Components.PlayerMoraleIndicatorComponent,
        Components.DrawingNationalPairs,
        Components.DrawWCGroupLooserModal,
        Components.NationalTeamShortModal,
        Components.DrawingWCPlayOff,
        Components.MaintenanceLog,
        Components.ChangeStandardRoleOrderModal,
        Components.OrderComponent,
        Components.DrawingClubWCGroup,
        Components.DrawingClubWCPlayOff,
        Components.PlayerPositionFilterModal,
        Components.PlayerAgeFilterModal,
    ],
    providers: [],
    entryComponents: [
    ],
})
export class ComponentsModule { 
    constructor() { }
}